module.exports = __webpack_public_path__ + "static/media/3-1_Plastic_Windows.d50a8b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/3-1_Plastic_Windows.jpg
// module id = 1732
// module chunks = 0